import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../api.service';

@Injectable({
  providedIn: 'root',
})
export class S3Service extends ApiService {
  uploadFile(url: string, file: File): Observable<unknown> {
    return this.http.put<unknown>(url, file);
  }
}
